<template>
    <div>
        <div class="contacts" v-if="projectPhoneSchema">
            <ui-input-field :field="projectPhoneSchema.project_phone_field" @enter="changeProjectPhone"
                            @blur="changeProjectPhone"
                            @focus="alert('rtrtrt')"
                            v-model="projectPhone"></ui-input-field>
        </div>
        <div class="contacts" v-if="projectAddressSchema">
            <ui-input-field :field="projectAddressSchema.project_address_field" @enter="changeProjectAddress"
                            @blur="changeProjectAddress"
                            v-model="projectAddress"></ui-input-field>
        </div>
        <div class="contacts" v-if="projectEmailSchema">
            <ui-input-field :field="projectEmailSchema.project_email_field" @enter="changeProjectEmail"
                            @blur="changeProjectEmail"
                            v-model="projectEmail"></ui-input-field>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import uiInputField from "vueComponents/ui-elements/fields/Input";

    /**
     * Компонент для изменения названия проекта
     *
     *  - projectNameSchema - данные с бэка с учетом языка
     *  <ui-input-field> - инпут для изменения названия
     *
     * @vuedoc
     * @module vue:components/ProjectName
     * @exports vue:components/ProjectName
     */
    export default {
        name: "detail-project-info",

        props: ['project_id'],

        components: {
            'ui-input-field': uiInputField,
        },

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {boolean} isRename - Флаг, активна ли возможность изменения названия проекта
         * @property {string} projectName - Название проекта
         */
        data() {
            return {
                isRename: false,
                projectPhone: "",
                projectAddress: "",
                projectEmail: "",
            }
        },

        computed: {

            ...mapGetters('project', [
                'projectPhoneSchema', 'projectAddressSchema', 'projectEmailSchema',
            ]),
        },

        mounted() {
            this.$store.dispatch('project/getProjectPhoneSchema', this.project_id);
            this.$store.dispatch('project/getProjectAddressSchema', this.project_id);
            this.$store.dispatch('project/getProjectEmailSchema', this.project_id);
        },


        watch: {},

        methods: {

            /**
             *  Изменяет email для проекта
             *
             * @method changeProjectEmail
             */
            changeProjectEmail() {
                if (this.projectEmail) {
                    this.$store.dispatch('project/changeProjectEmail', {
                        "projectId": this.project_id,
                        "newProjectEmail": this.projectEmail
                    });
                }
            },

            /**
             *  Изменяет телефон для проекта
             *
             * @method changeProjectEmail
             */
            changeProjectPhone() {
                if (this.projectPhone) {
                    this.$store.dispatch('project/changeProjectPhone', {
                        "projectId": this.project_id,
                        "newProjectPhone": this.projectPhone
                    });
                }
            },

            /**
             *  Изменяет адрес для проекта
             *
             * @method changeProjectAddress
             */
            changeProjectAddress() {
                if (this.projectAddress) {
                    this.$store.dispatch('project/changeProjectAddress', {
                        "projectId": this.project_id,
                        "newProjectAddress": this.projectAddress
                    });
                }
            },
        }
    }


</script>